import ItemIdentifier, { toItemIdentifierQueryParams } from './ItemIdentifier';
import SearchLimitOffset from './SearchLimitOffset';

/**
 * 機器検索条件
 */
export default interface SearchItemsRequest extends SearchLimitOffset {
  item?: ItemIdentifier | ItemIdentifier[];
  /**
   * 顧客設備ID
   */
  eqid?: number | number[];
  /**
   * 顧客ID
   */
  id?: number;
  /**
   * 機器名称または単位名称（部分一致）
   */
  name?: string;
}

export function toSearchItemsRequestParams(
  request?: SearchItemsRequest,
):
  | (Omit<SearchItemsRequest, 'item'> & { item?: string | string[] })
  | undefined {
  if (request == null) {
    return undefined;
  }
  const { item, ...rest } = request;
  return {
    ...rest,
    item: toItemIdentifierQueryParams(item),
  };
}
